import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { SectionName } from '_gql'

import { FormattedMessage } from '@divvy-web/i18n'
import { NavigationLink } from '@divvy-web/skylab.mainnavigation'

import ApplicationProgress from '@sputnik/pages/CreditApplicationPages/Navigation/ApplicationProgress'
import { useApplicationProgress } from '@sputnik/pages/CreditApplicationPages/Navigation/useApplicationProgress'
import { PATHNAME_CONSTS } from '@sputnik/resources/constants'
import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

const PeopleInfoNavSection = () => {
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const { tracker } = useWebTracking()

  const completionStatus = useApplicationProgress({ sectionName: SectionName.PEOPLE_INFO })
  const isPeopleInfoActive = pathname.includes(PATHNAME_CONSTS.PEOPLE_INFO_PATH)
  return (
    <NavigationLink
      dataTestId='people-info-navigation-link'
      icon={<ApplicationProgress status={completionStatus} />}
      isActive={isPeopleInfoActive}
      isExact={isPeopleInfoActive}
      label={
        <FormattedMessage
          defaultMessage='People info'
          id='sputnik.PeopleInfoNavSection__KC9gEO'
        />
      }
      onClick={() => {
        tracker?.track('se_signup__left_nav_menu_section_change__fired', {
          navigated_to_page: PATHNAME_CONSTS.PEOPLE_INFO_PATH,
        })
        navigate({ pathname: PATHNAME_CONSTS.PEOPLE_INFO_PATH }, { replace: true })
      }}
    />
  )
}

export default PeopleInfoNavSection
